import React, { useState, useEffect } from 'react';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';

import './index.css';

type DropdownProps = {
    className?: string;
    data: any[];
    dataKey?: string;
    disabled?: boolean;
    onSelect: (value: any) => void;
    setDefault?: (value: any) => void;
    label?: string;
    placeholder?: string;
    required?: boolean;
    value?: any;
}

function Dropdown({
    className,
    data,
    dataKey,
    disabled,
    onSelect,
    setDefault,
    label,
    placeholder,
    required,
    value
}: DropdownProps) {
    const [isOpen, setIsOpen] = useState(false);

    const ref = useOutsideClickHandler(() => setIsOpen(false));

    const selectItem = (item: any) => {
        onSelect(item);
        setIsOpen(false);
    }

    useEffect(() => {
        // sorting datas
        // data = data.sort();

        // assign default value
        if (data.length > 0 && setDefault) {
            if(localStorage.getItem('organization')){
                const organization = localStorage.getItem('organization');
                setDefault(organization);
            }
            else{
                setDefault(data[0]);
            }
        }
    }, []);

    return (
        <div
            className={disabled
                ? `dropdown--disabled ${className}`
                : isOpen
                ? `dropdown--open ${className}`
                : `dropdown ${className}`
            } 
            ref={ref}
        >
            {label &&
                <p className='dropdown__label'>
                    {label} {required && '*'}
                </p>
            }
            <div className='dropdown__value' onClick={() => !disabled && setIsOpen(!isOpen)}>
                {value
                    ?   <p>{value}</p>
                    :   placeholder
                    ?   <p className='dropdown__placeholder'>
                            {placeholder}
                        </p>
                    :   ''
                }
                {!disabled && isOpen &&
                    <div className='dropdown__items'>
                        {data.map((item, i) => (
                            <p
                                key={i} 
                                className='dropdown__item'
                                onClick={() => selectItem(item)}
                            >
                                {dataKey ? item[dataKey] : item}
                            </p>
                        ))}
                    </div>
                }
                {isOpen
                    ? <FaCaretUp className='dropdown__icon' />
                    : <FaCaretDown className='dropdown__icon' />
                }
            </div>
        </div>
    );
}

export default Dropdown;